import { render, staticRenderFns } from "./BtcLabelInput.vue?vue&type=template&id=00afe33b&scoped=true&"
import script from "./BtcLabelInput.vue?vue&type=script&lang=ts&"
export * from "./BtcLabelInput.vue?vue&type=script&lang=ts&"
import style0 from "./BtcLabelInput.vue?vue&type=style&index=0&id=00afe33b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00afe33b",
  null
  
)

export default component.exports